import { useGetBodyParts } from '@vindr/services/actions/bodyPart.action';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { Select } from 'antd';
import { FormItemProps } from '../templates/FormProps';
import FormSelect from '../templates/FormSelect';

interface Department extends FormItemProps {
  keyValue?: 'code' | 'id' | 'name';
  [key: string]: any;
}

const BodyPart = ({
  name = 'body_part',
  label = 'Body Part',
  placeholder = 'Select Body Part',
  rules,
  multiple = false,
  required = false,
  onChange,
  keyValue = 'name',
  disabled,
  ...props
}: Department) => {
  const { data, isLoading } = useGetBodyParts({ limit: 100, offset: 0 });

  const departments = data?.data;

  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <FormSelect
      {...(multiple && { mode: 'multiple' })}
      loading={isLoading}
      {...(onChange && { onChange })}
      {...(rules || (required && { rules: rulesMemo }))}
      {...{ name, label, placeholder, disabled, ...props }}
    >
      {departments?.map((department) => (
        <Select.Option key={department.id} value={department[keyValue]}>
          {department.name}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default BodyPart;
